import { createApi } from "../../../utils/createApi";
import { saveAs } from "file-saver";

export const downloadSiteReport = async (
  siteId: string,
  startDate?: Date | null,
  endDate?: Date | null
) => {
  const AxiosUI = createApi("");
  let endpoint = `autopatrol_data/report_by_site_id/?site_id=${siteId}`;

  if (startDate) {
    const normalizedStartDate = new Date(startDate);
    normalizedStartDate.setHours(0, 0, 0, 0);
    const startTimestamp = Math.floor(normalizedStartDate.getTime() / 1000);
    endpoint += `&start_timestamp=${startTimestamp}`;
  }

  if (endDate) {
    const normalizedEndDate = new Date(endDate);
    normalizedEndDate.setHours(23, 59, 59, 999);
    const endTimestamp = Math.floor(normalizedEndDate.getTime() / 1000);
    endpoint += `&end_timestamp=${endTimestamp}`;
  }

  const response = await AxiosUI.get(
    endpoint,
    { responseType: "blob" }
  );
  const blob = new Blob([response.data], { type: "text/csv" });
  saveAs(blob, `patrol_report_site_${siteId}.csv`);
};
